<template>
  <v-container fluid fill-height align-start ma-0 pa-0 class="notice">
    <!-- 미리보기 팝업 -->
    <i-dxpopup
      :popupVisible="popupVisible"
      :title="popupTitle"
      @popupCloseButtonClick="popupCloseButtonClick"
      :vHtmlContent="'test'"
      :height="'650'"
      width="90vw"
      max-width="650"
    >
      <template v-slot:grid>
        <i-preview :key="componentKey" :fileList="files" :propsFileData="selectedFileData"></i-preview>
      </template>
    </i-dxpopup>
    <v-row no-gutters v-if="files.length > 0">
      <v-col md="12" lg="9">
        <span class="form-label">{{ title }}</span>
        <div class="d-flex flex-wrap">
          <v-card v-for="file in files" :key="file.id" color="file_bg" flat width="200" class="mr-2 pa-3">
            <div class="d-flex align-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <p
                    v-bind="attrs"
                    v-on="on"
                    :class="{ strikethrough: saveFileList.delete.includes(file) }"
                    class="file-text"
                    @click="fileDownload(file)"
                  >
                    {{ file.fileNm }}.{{ file.extension }}
                  </p>
                </template>
                <span>{{ file.fileNm }}.{{ file.extension }}</span>
              </v-tooltip>

              <v-btn icon color="primary" @click="fileDownload(file)">
                <svg-icon icon-class="download" width="24" />
              </v-btn>
              <v-btn v-if="!readOnly" icon color="error">
                <svg-icon :icon-class="saveFileList.delete.includes(file) ? 'reload' : 'delete'" @click="toggleFileRemove(file)" />
              </v-btn>
            </div>
            <div class="mt-5 file-size">{{ file.fileSize }}</div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-sheet no-gutters v-if="!readOnly" style="width:100%;" :class="{ 'mt-5': files.length > 0 }">
      <span class="editor-label pa-0" :class="required ? 'required' : ''">{{ title }}</span>
      <v-layout column>
        <div style="text-align: right;" class="widget-container">
          <DxFileUploader
            :ref="dxFileUploader"
            :accept="fileExtension"
            :multiple="true"
            upload-mode="useButtons"
            :show-file-list="false"
            select-button-text="업로드"
            labelText
            width="100%"
            :dialog-trigger="'#btnUpload' + id"
            drop-zone="#dropzone-external"
            @uploaded="onUploaded"
            @upload-error="onUploadError"
            @value-changed="onValueChanged"
            :visible="false"
          />
        </div>

        <!-- 드래그 존  -->
        <div id="dropzone-external" :class="{ newFile: newFiles.length > 0 }">
          <div class="file-icon">
            <svg-icon icon-class="file-success" width="20" />
          </div>
          <span class="file-notice01">여기에 파일 놓기</span>
          <section class="newFile-top">
            <v-card v-for="file in newFiles" :key="file.id" color="file_bg" flat width="200" class="mr-2 pa-3">
              <div class="d-flex align-center">
                <p class="file-text new" @click="fileDownload(file)">{{ file.fileNm }}.{{ file.extension }}</p>
                <v-btn icon color="error" @click="newFileRemove(file)">
                  <svg-icon icon-class="delete" width="24" />
                </v-btn>
              </div>
              <div class="mt-5 file-size">{{ file.fileSize }}</div>
            </v-card>
          </section>
          <section class="newFile-bottom">
            <span class="file-notice02">100MB 이하 파일만 가능합니다.</span>
            <v-btn :id="'btnUpload' + id" text color="secondary">파일 업로드</v-btn>
          </section>
        </div>
      </v-layout>
    </v-sheet>
  </v-container>
</template>

<script>
import { deleteFiles, downloadFile, getFile, multiFileUpload } from '@/api/baseManage/fileUpload'
import iDxPopup from '@/components/common/iDxPopup.vue'
import IPreview from '@/components/common/iPreview.vue'
import { getCurrentDate } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
import notify from 'devextreme/ui/notify'

import { DxFileUploader } from 'devextreme-vue/file-uploader'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'iFileManage',
  components: { DxFileUploader, 'i-dxpopup': iDxPopup, IPreview },
  props: {
    id: {
      // dialog-trigger 중복 방지를 위한 ID 값
      type: String,
      default: () => ''
    },
    targetId: {
      type: String,
      default: () => ''
    },
    targetType: {
      type: String,
      default: () => ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    fileExtension: {
      type: String,
      default: () => '*'
    },
    title: {
      type: String,
      default: () => '업로드파일'
    },
    required: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      componentKey: 0,
      popupVisible: false,
      popupTitle: '미리보기',
      buttonUseList: [
        'btnUpload', //업로드
        'btnDelete' //삭제
      ],
      dxDataGridRef: 'fileDataGrid',
      dxFileUploader: 'uploaderContainer',
      files: [],
      newFiles: [],
      maxFileSize: 104857600,
      clntId: this.getClntId(),
      selectedFileData: 0,
      saveFileList: {
        insert: [],
        delete: []
      }
    }
  },
  watch: {
    targetId(newVal, oldVal) {
      // 문서 다를 경우 초기화
      if (newVal !== oldVal) {
        this.files = []
        this.newFiles = []
      }
    }
  },
  computed: {
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance
    }
  },
  beforeMount() {},
  created() {},
  mounted() {},
  activated() {
    this.saveFileList = { insert: [], delete: [] }
    // 신규 문서일시 초기화
    // if (this.targetId === '') {
    //   this.files = []
    // }
  },
  methods: {
    validateSave() {
      // 파일업로드가 필수 사항일 때 저장가능 여부 판단 메서드
      // 부모에서 이 메서드를 호출하여 validation 체크 진행
      console.log('@@ this.files', this.files, this.newFiles)
      let validData = this.files.filter(el => el.__deleted__ != true)
      if (validData.length > 0 || this.newFiles.length > 0) {
        return true
      } else return false
    },
    forceRerender() {
      this.componentKey += 1
    },
    btnSearch(noti) {
      this.clntId = this.getClntId()
      let searchParams = {
        targetId: this.targetId,
        targetType: this.targetType,
        clntId: this.targetId?.split('_')[0]
      }
      getFile(searchParams, noti)
        .then(res => {
          if (res.success) {
            this.files = []
            res.list.forEach(el => {
              el.__deleted__ = false
              if (el.targetId === searchParams.targetId) this.files.push(el)
            })
            // console.log('13123', this.files)
          }
        })
        .finally()
    },
    async btnSave(fileList) {
      await this.fileRemove(fileList.delete) // 삭제리스트 파일 삭제
      await this.fileSave(fileList.insert)
      this.saveFileList = {
        insert: [],
        delete: []
      }
      console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
      console.log(this.saveFileList)
      console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
      this.newFiles = []
    },
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      let newData = this.files.slice() // 기존 files 배열을 복사하여 newData 초기화
      this.vToastifyPrompt(
        this.$t('파일을 삭제하시겠습니까?'),
        'info',
        current => {
          selectedRows.forEach(row => {
            // 각 선택된 행에 대해 해당 행의 id와 일치하지 않는 파일만 필터링하여 newData에 추가
            newData = newData.filter(file => row.id != file.id)
          }) // 그리드에서 해당데이터 제거
          this.files = newData
          // this.saveFileList.insert.findIndex(el=> el.id === newData.)
          // this.saveFileList.insert = newData
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.saveFileList.delete = [...this.saveFileList.delete, ...selectedRows] //삭제 파일 리스트 보관
          let newInsert = this.saveFileList.insert.slice()
          this.saveFileList.delete.forEach(del => {
            newInsert = newInsert.filter(ins => del.id != ins.id)
          })
          this.saveFileList.insert = newInsert
          this.$emit('onFileChanged', this.saveFileList)
        },
        null,
        true
      )

      // this.fileRemove(selectedRows)
    },
    fileSave(selectedRows) {
      if (selectedRows.length > 0) {
        return new Promise((resolve, reject) => {
          this.openLoading()
          // this.GetDataGrid(this.dxDataGridRef).saveEditData()
          let formData = new FormData()
          let i = 0
          selectedRows.forEach(element => {
            formData.append('fileList[' + i + '].fileData', element.file ? element.file : new Blob([], { type: 'application/octet-stream' }))
            formData.append('fileList[' + i + '].fileVO.targetId', this.targetId)
            formData.append('fileList[' + i + '].fileVO.targetType', this.targetType)
            formData.append('fileList[' + i + '].fileVO.useYn', element.useYn)
            formData.append('fileList[' + i + '].fileVO.clntId', this.clntId)
            i++
          })
          multiFileUpload(formData, false)
            .then(res => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .finally(() => {
              this.endLoading()
              resolve(true)
            })
        })
      }
    },
    fileRemove(files) {
      console.log(files)
      if (files.length > 0) {
        this.openLoading('deleting')
        deleteFiles(files, false)
          .then(res => {
            if (res.success) {
              this.btnSearch(false)
            }
          })
          .finally(() => {
            this.endLoading()
          })
      }
    },
    newFileRemove(file) {
      const currentIndex = this.saveFileList.insert.indexOf(file)
      this.saveFileList.insert.splice(currentIndex, 1)
      this.newFiles = this.newFiles.filter(row => row.id !== file.id)
    },
    previewClick(data) {
      this.selectedFileData = data
      this.forceRerender()
      this.popupVisible = true
    },
    fileDownload(rowData) {
      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        clntId: rowData.clntId,
        writeDt: rowData.writeDt,
        docNo: rowData.docNo
      }

      downloadFile(params)
        .then(res => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${rowData.fileNm}.${rowData.extension}`
          link.click()
        })
        .finally(() => this.endLoading())
    },
    popupCloseButtonClick() {
      this.selectedFileData = null
      this.popupVisible = false
    },
    onUploaded(e) {
      e.component._files.forEach((element, index) => {
        if (element._isLoaded) {
          this.fileUploader.removeFile(index)
        }
      })
      notify(this.$t('파일이 업로드 되었습니다.'), 'success', 300)
    },
    onUploadError(e) {
      e.component._files.forEach((element, index) => {
        if (element._isError) {
          this.fileUploader.removeFile(index)
          this.vSnackbar(this.$t('파일을 업로드 할 수 없습니다.'), 'warn')
        }
      })
    },
    onValueChanged(e) {
      console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', e)
      // reset 이벤트는 재귀적으로 이 이벤트를 부르기 때문에 0일때 return 시킴
      if (e.value == null || e.value.length == 0) return

      this.openLoading()
      for (const element of e.value) {
        if (element.size >= this.maxFileSize) {
          this.vSnackbar(this.$t('파일이 용량이 100MB를 초과했습니다.'), 'warn')
          continue
        }
        let subFileName = this.getExtension(element.name)
        //   if (subFileName[0].length > 200) {
        //     notify(this.$t('파일의 이름이 200자 이상입니다.'), 'error', 300)
        //     continue
        //   }
        //   // if (!this.allowedFileExtensions.includes('.' + subFileName[1])) {
        //   //   notify(this.$t('업로드할 수 없는 확장자입니다.'), 'error', 300)
        //   //   continue
        //   // }
        let writeDt = getCurrentDate()
          .split('-')
          .join('')
        let newRow = {
          id: this.newFiles.length + 1,
          clntId: this.clntId,
          writeDt: writeDt,
          doc_no: (this.files.length + 1).toString().padStart(5, '0'),
          file: new File([element], `${subFileName[0]}.${subFileName[1]}`),
          fileNm: subFileName[0],
          extension: subFileName[1],
          fileSize: this.getfileSize(element.size),
          useYn: 'Y',
          targetId: this.targetId,
          targetType: this.targetType
        }

        //   Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })

        this.newFiles.unshift(newRow)
        this.saveFileList.insert = [...this.saveFileList.insert, ...[newRow]]
        //   this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
        console.log('@@ this.saveFileList', this.saveFileList)
      }
      // this.GetDataGrid(this.dxDataGridRef).updateDimensions()
      this.fileUploader.reset()
      this.$emit('onFileChanged', this.saveFileList)
      this.endLoading()
    },
    getExtension(fileName) {
      let fileLen = fileName.length

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot + 1, fileLen).toLowerCase()
      let baseName = fileName.substring(0, lastDot)
      return [baseName, extension]
    },
    getfileSize(size) {
      let fileSize = ''
      if (size < 1048576) {
        fileSize = (size / 1024).toFixed(3) + 'KB'
      } else {
        fileSize = (size / 1048576).toFixed(3) + 'MB'
      }
      return fileSize
    },
    openFileDialog() {
      // DxFileUploader의 내부 input에 접근하여 클릭 이벤트를 트리거
      this.$refs.dxFileUploader.$el.querySelector('.dx-fileuploader-input').click()
    },
    toggleFileRemove(file) {
      file.__deleted__ = !file.__deleted__
      const currentIndex = this.saveFileList.delete.indexOf(file)
      if (currentIndex === -1) {
        this.saveFileList.delete.push(file)
      } else {
        this.saveFileList.delete.splice(currentIndex, 1)
      }
      this.$emit('onFileChanged', this.saveFileList)
    }
  }
}
</script>

<style lang="scss">
#dropzone-external {
  min-height: 160px;
  padding: 24px;
  background-color: #fbfcfe;
  border-radius: 4px;
  border: 1px solid #e4e4ed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .file-icon {
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    background: #eef0f4;
    color: #130953;
  }
  .file-notice01 {
    color: rgba(0, 0, 0, 0.25);
    font-size: 1rem;
    font-weight: 400;
    margin: 12px auto 8px;
  }
  .file-notice02 {
    font-size: 0.85714rem;
    color: rgba(0, 0, 0, 0.25);
    font-weight: 400;
  }
  .newFile-top {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 8px;
  }
  .newFile-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #btnUpload {
    padding: 0;
    height: unset;
    margin-top: 8px;
    .v-btn__content {
      font-size: 1rem;
      font-weight: 500;
      border-bottom: 1px solid #130953;
    }
  }
  &.newFile {
    align-items: flex-start;
    .file-icon,
    .file-notice01 {
      display: none;
    }
    .newFile-bottom {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
    }
  }
}

.file-text {
  color: #000;
  font-size: 0.875rem;
  width: 100%;
  cursor: pointer; /* 기본 커서를 포인터 모양으로 설정 */
  margin-bottom: 0 !important;
  white-space: nowrap; /* 텍스트가 요소의 영역을 벗어나지 않도록 함 */
  overflow: hidden; /* 요소 내부의 내용이 영역을 벗어나면 숨김 */
  text-overflow: ellipsis; /* 텍스트가 잘리면 ...으로 표시 */
  &:not(.new) {
    text-decoration: underline; /* 텍스트에 밑줄 추가 */
  }
}

.file-text:hover {
  cursor: pointer; /* 마우스가 요소 위에 있을 때 커서를 포인터 모양으로 변경 */
}

.file-size {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.875rem;
}

.strikethrough {
  text-decoration: line-through;
  color: #a0a6b5;
}
</style>
